import axios from 'axios';
import { DB_URL } from '../../util/DB_URL';
import Strapi from 'strapi-sdk-js';

const strapi = new Strapi({
  url: DB_URL,
  prefix: '/api',
});

export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';
export const RESET_CART = 'RESET_CART';
export const GET_STATUS = 'GET_STATUS';
export const GET_ORDERS = 'GET_ORDERS';
export const SET_CART = 'SET_CART';

export function selectProduct(id) {
  return async function (dispatch) {
    const { data } = await strapi.findOne('products', id, {
      populate: {
        product_categories: {
          fields: ['id', 'name'],
        },
        product_pages: 'product_pages',
        product_part_orders: {
          product_part: {
            populate: {
              specs: 'specs',
            },
          },
        },
        product_sum_orders: {
          product_sum: {
            populate: {
              sum_type: 'sum_type',
            },
          },
        },
        product_attribute_orders: {
          populate: {
            product_attribute: {
              populate: {
                product_options: {
                  fields: ['id', 'name', 'values'],
                },
                products: {
                  fields: ['id'],
                },
              },
              fields: ['id', 'name', 'parts', 'description'],
            },
          },
        },
        parts: {
          fields: ['id', 'name', 'breakdown', 'qty'],
        },
        media: 'media',
      },
    });

    return dispatch({
      type: SELECT_PRODUCT,
      data: data,
    });
  };
}

export function setCart(cart) {
  return async function (dispatch) {
    return dispatch({
      type: SET_CART,
      data: cart,
    });
  };
}

export function addToCart(product) {
  return async function (dispatch) {
    return dispatch({
      type: ADD_TO_CART,
      data: product,
    });
  };
}

export function deleteFromCart(product) {
  return async function (dispatch) {
    return dispatch({
      type: DELETE_FROM_CART,
      data: product,
    });
  };
}

export function resetCart(product) {
  return async function (dispatch) {
    return dispatch({
      type: RESET_CART,
    });
  };
}

export function getStatus(cookie) {
  return async function (dispatch) {
    const data = await axios.get(`${DB_URL}/api/statuses?sort=id:asc`, {
      //   headers: {
      //     Authorization: `Bearer ${cookie}`,
      //   },
    });

    return dispatch({
      type: GET_STATUS,
      data: data.data,
    });
  };
}

export function getOrders(order) {
  return async function (dispatch) {
    return dispatch({
      type: GET_ORDERS,
      data: order,
    });
  };
}
